import React, { useState, useEffect } from "react";
import {
  Form
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "./index.css";

import { Creators as VirtualFenceActions } from "../../store/ducks/virtualFences";

const VirtualFenceSearch = ({
  props: { virtualFencesSearchQuery },
  funcs: { searchVirtualFence }
}) => {
  const { t } = useTranslation();
  const [virtualFencesSearch, setNotificationsSearch] = useState({
    word: ""
  });

  useEffect(() => {
    searchVirtualFence(virtualFencesSearch);
  }, [virtualFencesSearch, searchVirtualFence]);

  useEffect(() => {
    setNotificationsSearch(prevState => ({
      ...prevState
    }));
  }, [virtualFencesSearchQuery]);

  return (
    <form onSubmit={e => e.preventDefault()}>
      <Form.Group controlId="virtual-fences-item-form-search">
        <Form.Control
          type="text"
          placeholder={t("Placeholder.Search")}
          autoComplete={"off"}
          onChange={e => setNotificationsSearch(prevState => ({
            ...prevState,
            word: e.target.value
          }))}
          value={virtualFencesSearch.word}
          disabled={false}
        />
      </Form.Group>
    </form>
  );
};

const mapStateToProps = state => ({
  props: {
    virtualFencesSearchQuery: state.virtualFences.positionsSearchQuery
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, VirtualFenceActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualFenceSearch);
